// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-dropdown {
  border-radius: 4px;
  padding-top: 8px;
  overflow-y: hidden;
}
.bolt-dropdown .bolt-list-row.selected .bolt-list-cell:first-child {
  border-left: 0px none transparent;
}

.bolt-dropdown-list-box-container {
  max-height: 270px;
  padding-bottom: 8px;
}

.bolt-dropdown .bolt-dropdown-list-box-container {
  overflow-x: hidden;
  overflow-y: auto;
}

.bolt-dropdown-filter.bolt-textfield {
  background: rgba(0, 0, 0, 0.06);
  background: var(--palette-black-alpha-6,rgba(0, 0, 0, 0.06));
  border-radius: 2px;
  border-color: transparent;
}
.bolt-dropdown-filter.bolt-textfield .bolt-textfield-input {
  background: transparent;
}

.bolt-dropdown-filter-container {
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
}

.bolt-actions-container {
  border-top: 1px solid;
  border-top-color: rgba(0, 0, 0, 0.06);
  border-top-color: var(--palette-black-alpha-6,rgba(0, 0, 0, 0.06));
  padding: 8px;
  align-items: flex-start;
}

.bolt-dropdown-no-items {
  padding: 6px 10px;
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
  text-align: center;
}

.bolt-focus-visible .bolt-dropdown .bolt-table-row.focused {
  outline: none;
  animation: focus-shadow-pulse-inset 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-dropdown .bolt-table-row.focused {
    animation: none;
  }
}
.bolt-focus-visible .bolt-dropdown .bolt-table-row.focused {
  box-shadow: inset 0 0 0 3px rgba(0, 120, 212, 0.23), inset 0 0 0 1px rgba(0, 120, 212, 1);
  box-shadow: inset 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23)), inset 0 0 0 1px var(--focus-border-color,rgba(0, 120, 212, 1));
}

_::-webkit-full-page-media,
_:future,
:root .bolt-focus-visible .bolt-dropdown .bolt-table-row.focused {
  outline-style: auto;
}

.bolt-dropdown-action-right-button {
  margin: 8px 4px 0px 0px;
  align-self: flex-end;
}

.bolt-dropdown-expandable-textfield-input {
  text-align: left;
  min-width: 0;
}
@media (forced-colors: active) {
  .bolt-dropdown-expandable-textfield-input {
    forced-color-adjust: none;
    border-color: highlight;
  }
}
@media screen and (forced-colors: active) and (prefers-color-scheme: light) {
  .bolt-dropdown-expandable-textfield-input {
    outline: 1px solid highlight;
    outline-offset: 1px;
  }
}
@media (forced-colors: active) {
  .bolt-dropdown-expandable-textfield-input {
    background: window;
    color: windowtext !important;
    forced-color-adjust: auto;
  }
}

.bolt-dropdown-expandable-textfield-input:empty {
  min-height: 29px !important;
}

.bolt-dropdown-expandable-textfield-input::-moz-focus-inner {
  border: 0;
}

.bolt-dropdown-expandable-textfield-input.bolt-textfield-input {
  background-color: transparent;
}

.bolt-dropdown-expandable-button-label {
  text-align: left;
}

.bolt-dropdown-filter-bar-item {
  max-width: 100%;
}
.bolt-dropdown-filter-bar-item .bolt-button {
  max-width: 100%;
}

.bolt-dropdown-filter-bar-item .bolt-dropdown-expandable-button-label {
  max-width: 340px;
  font-weight: normal;
}
.bolt-dropdown-filter-bar-item .bolt-dropdown-expandable-button-label .bolt-dropdown-filter-bar-item-selected-text {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}
@media (forced-colors: active) {
  .bolt-dropdown-filter-bar-item .bolt-dropdown-expandable-button-label .bolt-dropdown-filter-bar-item-selected-text {
    color: windowText;
  }
}

.bolt-dropdown-filter-bar-item-selected-text {
  font-weight: 600;
}

.bolt-dropdown-filter-bar-item-placeholder {
  white-space: pre;
}

.bolt-dropdown-filter-bar-item .bolt-button {
  background: transparent;
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}
.bolt-dropdown-filter-bar-item .bolt-button.active {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}

.bolt-dropdown-pivot.bolt-button.subtle:hover {
  background: transparent;
}
.bolt-dropdown-pivot.bolt-button.subtle {
  font-weight: normal;
}

.bolt-dropdown-pivot-selected {
  border-bottom: 2px solid rgba(0, 120, 212, 1);
  border-bottom: 2px solid var(--communication-background,rgba(0, 120, 212, 1));
  font-weight: 600;
}

.bolt-dropdown-header {
  padding: 0 4px 4px 12px;
}

.bolt-dropdown-header-text {
  padding: 6px 0;
}

.bolt-dropdown-header-container {
  border-bottom: 1px solid;
  border-bottom-color: rgba(0, 0, 0, 0.06);
  border-bottom-color: var(--palette-black-alpha-6,rgba(0, 0, 0, 0.06));
}

.bolt-dropdown-expandable-text-field:not(.disabled) {
  cursor: pointer;
}
.bolt-dropdown-expandable-text-field:not(.disabled) .bolt-dropdown-expandable-textfield-input {
  cursor: pointer;
}

/*# sourceMappingURL=Dropdown.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Dropdown/Dropdown.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/Dropdown/Dropdown.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AACA;EACI,kBC+SQ;ED9SR,gBCkTQ;EDjTR,kBAAA;AEAJ;AFEI;EACI,iCAAA;AEAR;;AFIA;EACI,iBAAA;EACA,mBCwSQ;ACzSZ;;AFIA;EACI,kBAAA;EACA,gBAAA;AEDJ;;AFIA;EACI,+BC2Gc;ED1Gd,4DAAA;EACA,kBAAA;EEDF,yBAAyB;AFGvB;AEDJ;EACE,uBAAuB;AACzB;;AAEA;EFII,iBCoRQ;EDnRR,kBCmRQ;ECrRV,mBAAmB;AACrB;;AAEA;EFII,qBC0Fc;EDzFd,qCC6QQ;ED5QR,kEAAA;EEFF,YAAY;EACZ,uBAAuB;AFIzB;;AEDA;EFII,iBAAA;EEFF,yBAAyB;EACzB,qDAAqD;EFIvD,kBAAA;AEFA;;AAEA;ECHI,aAAA;EHGJ,2DAAA;AEGA;AACA;EACE;IFLF,eAAA;EGgBQ;ADRR;AACA;EFHA,yFAAA;EAAA,gJAAA;AAAA;;AEQA;;;EFCI,mBAAA;AEGJ;;AAEA;EFDA,uBAAA;EACI,oBAAA;AEGJ;;AC1BI;EHsBJ,gBAAA;EEQE,YCOM;ADNR;AACA;EACE;ICQE,yBAAA;IHnBJ,uBAAA;EEcE;AACF;AACA;EACE;ICvCE,4BAAA;IHsBJ,mBAAA;EEoBE;AACF;AACA;EACE;IACE,kBAAkB;IAClB,4BAA4B;IFdhC,yBAAA;EACI;AEgBJ;;AFbA;EACI,2BAAA;AEgBJ;;AFbA;EACI,SAAA;AEgBJ;;AFbA;EACI,6BAAA;AEgBJ;;AFbA;EACI,gBAAA;AEgBJ;;AAEA;EACE,eAAe;AACjB;AFbA;EACI,eAAA;AEeJ;;AFZI;EACI,gBCgDO;ECjCb,mBAAmB;AC7EjB;AD+EJ;EACE,wBFhBU;EEiBV,kDAAkD;AACpD;AACA;EFdA;IACI,iBCgLiB;EChKnB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EFdI,gBCmCa;ACnBjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EFbvB,qDAAA;AEeJ;AACA;EFjBA,wBAAA;EAKI,kDCoJe;ACrInB;;AFZA;EACI,uBAAA;AEeJ;AACA;EACE,mBAAmB;AFbrB;;AEgBA;EACE,6CAA6C;EFb/C,6EAAA;EACI,gBAAA;AEeJ;;AFZA;EACI,uBAAA;AEeJ;;AAEA;EFbA,cAAA;AEeA;;AFZI;EACI,wBAAA;EEeN,wCAAwC;EACxC,qEAAqE;AACvE;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA,uCAAuC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
